module.exports = __webpack_public_path__ + "static/media/python1.53ce3e36.png";